"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.electionSchema = exports.electionBaseSchema = exports.electionSchemaReference = void 0;
const zod_1 = require("zod");
const calculator_group_schema_1 = require("./calculator-group.schema");
const district_schema_1 = require("./district.schema");
const round_schema_1 = require("./round.schema");
const tags_schema_1 = require("./tags.schema");
const time_period_schema_1 = require("./time-period.schema");
const electionIdSchema = zod_1.z.string().uuid().describe("Unique identifier of an election in the format of UUID");
const electionKeySchema = zod_1.z
    .string()
    .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)
    .describe("Human-friendly unique key of an election in the hyphen-separated lowercased format");
exports.electionSchemaReference = zod_1.z
    .object({
    id: electionIdSchema,
    key: electionKeySchema,
})
    .strict();
exports.electionBaseSchema = zod_1.z
    .object({
    id: electionIdSchema,
    key: electionKeySchema,
    createdAt: zod_1.z.string().datetime({ offset: true }).describe("Time of the creation of an election in the ISO 8601 format"),
    updatedAt: zod_1.z.string().datetime({ offset: true }).describe("Time of the last update of an election group in the ISO 8601 format").optional(),
    publishedAt: zod_1.z.string().datetime({ offset: true }).describe("Time when an election group should be published in the ISO 8601 format").optional(),
    title: zod_1.z.string().describe("Title of an election"),
    shortTitle: zod_1.z.string().max(25).describe("Short title of an election with a maximum of 25 characters"),
    description: zod_1.z.string().describe("Description of an election").optional(),
    tags: tags_schema_1.tagsSchema.optional(),
    calculatorGroup: zod_1.z.lazy(() => calculator_group_schema_1.calculatorGroupSchemaReference),
    districts: zod_1.z.array(district_schema_1.districtSchema).min(1).describe("Ordered list of election districts").optional(),
    rounds: zod_1.z.array(round_schema_1.roundSchema).min(1).describe("Ordered list of election rounds").optional(),
    votingHours: zod_1.z.array(time_period_schema_1.timePeriodSchema).min(1).describe("One or multiple voting hours for the election").optional(),
})
    .strict();
exports.electionSchema = exports.electionBaseSchema.refine((data) => !(data.rounds && data.votingHours), { message: "Cannot have both rounds and votingHours" });
